import { useEffect, useState } from 'react';
import { isLocalhost } from '../env';
import { waitFor } from './wait_for';

declare const AF_SMART_SCRIPT_RESULT: { clickURL: string } | undefined;

export const useAppsflyerSmartScriptURL = () => {
  const [appsFlyerURL, setAppsFlyerURL] = useState<string>('');

  useEffect(() => {
    if (isLocalhost()) {
      setAppsFlyerURL('https://apps.apple.com/us/app/omnia-fishing-lake-maps-gear/id1596505528');
    } else {
      waitFor(() => typeof AF_SMART_SCRIPT_RESULT !== 'undefined', 10_000)
        .then(() => {
          setAppsFlyerURL(AF_SMART_SCRIPT_RESULT.clickURL);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, []);

  return appsFlyerURL;
};
